import { api } from './api.js'

/** GET /clients?chain_id=X — returns { clients: [...], pagination: {} } */
export async function getClients(params = {}) {
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined))
  ).toString()
  return api.get(`/clients${qs ? '?' + qs : ''}`)
}

/** GET /clients/:id — full detail including price_list */
export async function getClient(id) {
  return api.get(`/clients/${id}`)
}

/** GET /center_orders — paginated list of orders */
export async function getCenterOrders(params = {}) {
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined))
  ).toString()
  return api.get(`/center_orders${qs ? '?' + qs : ''}`)
}
